import instance from '@/api/business' 
import { Resale } from '@/types/Resale' 
import { UpdateResaleOwnerParams } from './type'

const BASE_URL = '/resale/im/resale'

export const fetchResale = async () => {
    const response = await instance.post<Resale[]>(BASE_URL)

    return response.data
} 

export const updateResaleOwner = async (data: UpdateResaleOwnerParams) => {
    const response = await instance.post<{ status: number; message: string }>(`${BASE_URL}/owner`, data)

    return response.data
}